export default __webpack_public_path__ + "static/media/icon8.f29c5d23.svg";